import { Action } from '@ngrx/store';

import {
    SignInModel,
    SignUpModel,
    ForgotPasswordSubmitModel,
    ChangePasswordModel,
    UserAttributeModel
} from '@framework/cloud-authentication/cognito/models';

export enum ActionTypes {
    SIGNIN = '[Auth] Sign In',
    SIGNIN_SUCCESS = '[Auth] Sign In Success',
    SIGNIN_FAILURE = '[Auth] Sign In Failure',

    SSO = '[Auth] SSO',
    SSO_SUCCESS = '[Auth] SSO Success',
    SSO_FAILURE = '[Auth] SSO Failure',

    SIGNUP = '[Auth] Sign Up',
    SIGNUP_SUCCESS = '[Auth] Sign Up Success',
    SIGNUP_FAILURE = '[Auth] Sign Up Failure',

    VERIFY_ACCOUNT = '[Auth] Verify Account',
    VERIFY_ACCOUNT_SUCCESS = '[Auth] Verify Account Success',
    VERIFY_ACCOUNT_FAILURE = '[Auth] Verify Account Failure',

    RESEND_VERIFY_CODE = '[Auth] Resend Verify Code',
    RESEND_VERIFY_CODE_SUCCESS = '[Auth] Resend Verify Code Success',
    RESEND_VERIFY_CODE_FAILURE = '[Auth] Resend Verify Code Failure',

    SIGNOUT = '[Auth] Sign Out',

    FORGOT_PASSWORD = '[Auth] Forgot Password',
    FORGOT_PASSWORD_SUCCESS = '[Auth] Forgot Password Success',
    FORGOT_PASSWORD_FAILURE = '[Auth] Forgot Password Failure',

    FORGOT_PASSWORD_SUBMIT = '[Auth] Forgot Password Submit',
    FORGOT_PASSWORD_SUBMIT_SUCCESS = '[Auth] Forgot Password Submit Success',
    FORGOT_PASSWORD_SUBMIT_FAILURE = '[Auth] Forgot Password Submit Failure',

    CHANGE_PASSWORD = '[Auth] Change Password',
    CHANGE_PASSWORD_SUCCESS = '[Auth] Change Password Success',
    CHANGE_PASSWORD_FAILURE = '[Auth] Change Password Failure',

    UPDATE_ATTRIBUTE = '[Auth] Update Attribute',
    UPDATE_ATTRIBUTE_SUCCESS = '[Auth] Update Attribute Success',
    UPDATE_ATTRIBUTE_FAILURE = '[Auth] Update Attribute Failure',


    UPDATE_CONTACT           = '[Auth] Update Contact',
    UPDATE_CONTACT_SUCCESS   = '[Auth] Update Contact Success',
    UPDATE_CONTACT_FAILURE   = '[Auth] Update Contact Failure',


    RESET_CODE           = '[Auth] Reset Code',
    RESET_CODE_SUCCESS   = '[Auth] Reset Code Success',
    RESET_CODE_FAILURE   = '[Auth] Reset Code Failure',

    GET_PHONE_NUMBER           = '[Auth] Get Phone Number',
    GET_PHONE_NUMBER_SUCCESS   = '[Auth] Get Phone Number Success',
    GET_PHONE_NUMBER_FAILURE   = '[Auth] Get Phone Number Failure',

        // LOGIN
        SIGNUP_CODE_LOGIN = '[Auth] Signup Code Login',
        SIGNUP_CODE_LOGIN_SUCCESS = '[Auth] Signup Code Login Success',
        SIGNUP_CODE_LOGIN_FAILURE = '[Auth] Signup Code Login Failure',
    
        // GENERATE CODE
        GENERATE_SIGNUP_CODE = '[Auth] Generate Signup Code',
        GENERATE_SIGNUP_CODE_SUCCESS = '[Auth] Generate Signup Code Success',
        GENERATE_SIGNUP_CODE_FAILURE = '[Auth] Generate Signup Code Failure',
    
        // LIST CODES
        GET_SIGNUP_CODES = '[Auth] Get Signup Codes',
        GET_SIGNUP_CODES_SUCCESS = '[Auth] Get Signup Codes Success',
        GET_SIGNUP_CODES_FAILURE = '[Auth] Get Signup Codes Failure',
    
        // VALIDATE CODE
        VALIDATE_SIGNUP_CODE = '[Auth] Validate Signup Code',
        VALIDATE_SIGNUP_CODE_SUCCESS = '[Auth] Validate Signup Code Success',
        VALIDATE_SIGNUP_CODE_FAILURE = '[Auth] Validate Signup Code Failure',
    
        VALIDATE_EMAIL = '[Auth] Validate Email',
        VALIDATE_EMAIL_SUCCESS = '[Auth] Validate Email Success',
        VALIDATE_EMAIL_FAILURE = '[Auth] Validate Email Failure',


    GOTO_SIGNIN = '[Auth] Goto Signin',
    SET_REDIRECT_URL = '[Auth] Set Redirect URL',

    SET_GS_TOKEN = '[Auth] Set Gs Token'
}


export class SignIn implements Action {
    readonly type = ActionTypes.SIGNIN;

    constructor(public data: SignInModel) { }
}

export class SignInSuccess implements Action {
    readonly type = ActionTypes.SIGNIN_SUCCESS;

    constructor() { }
}

export class SignInFailure implements Action {
    readonly type = ActionTypes.SIGNIN_FAILURE;

    constructor(public error: any) { }
}

export class SSO implements Action {
    readonly type = ActionTypes.SSO;

    constructor(public data: SignInModel) { }
}

export class SSOSuccess implements Action {
    readonly type = ActionTypes.SSO_SUCCESS;

    constructor() { }
}

export class SSOFailure implements Action {
    readonly type = ActionTypes.SSO_FAILURE;

    constructor(public error: any) { }
}

export class SignUp implements Action {
    readonly type = ActionTypes.SIGNUP;

    constructor(public data: SignUpModel) { }
}

export class SignUpSuccess implements Action {
    readonly type = ActionTypes.SIGNUP_SUCCESS;

    constructor() { }
}

export class SignUpFailure implements Action {
    readonly type = ActionTypes.SIGNUP_FAILURE;

    constructor(public error: any) { }
}

export class VerifyAccount implements Action {
    readonly type = ActionTypes.VERIFY_ACCOUNT;

    constructor(public username: string, public code: string) { }
}

export class VerifyAccountSuccess implements Action {
    readonly type = ActionTypes.VERIFY_ACCOUNT_SUCCESS;

    constructor() { }
}

export class VerifyAccountFailure implements Action {
    readonly type = ActionTypes.VERIFY_ACCOUNT_FAILURE;

    constructor(public error: any) { }
}

export class ResendVerifyCode implements Action {
    readonly type = ActionTypes.RESEND_VERIFY_CODE;

    constructor(public username: string) { }
}

export class ResendVerifyCodeSuccess implements Action {
    readonly type = ActionTypes.RESEND_VERIFY_CODE_SUCCESS;

    constructor() { }
}

export class ResendVerifyCodeFailure implements Action {
    readonly type = ActionTypes.RESEND_VERIFY_CODE_FAILURE;

    constructor(public error: any) { }
}

export class SignOut implements Action {
    readonly type = ActionTypes.SIGNOUT;
}

export class ForgotPassword implements Action {
    readonly type = ActionTypes.FORGOT_PASSWORD;

    constructor(public username: string) { }
}

export class ForgotPasswordSuccess implements Action {
    readonly type = ActionTypes.FORGOT_PASSWORD_SUCCESS;

    constructor() { }
}

export class ForgotPasswordFailure implements Action {
    readonly type = ActionTypes.FORGOT_PASSWORD_FAILURE;

    constructor(public error: any) { }
}

export class ForgotPasswordSubmit implements Action {
    readonly type = ActionTypes.FORGOT_PASSWORD_SUBMIT;

    constructor(public data: ForgotPasswordSubmitModel) { }
}

export class ForgotPasswordSubmitSuccess implements Action {
    readonly type = ActionTypes.FORGOT_PASSWORD_SUBMIT_SUCCESS;

    constructor() { }
}

export class ForgotPasswordSubmitFailure implements Action {
    readonly type = ActionTypes.FORGOT_PASSWORD_SUBMIT_FAILURE;

    constructor(public error: any) { }
}

export class ChangePassword implements Action {
    readonly type = ActionTypes.CHANGE_PASSWORD;

    constructor(public data: ChangePasswordModel) { }
}

export class ChangePasswordSuccess implements Action {
    readonly type = ActionTypes.CHANGE_PASSWORD_SUCCESS;

    constructor() { }
}

export class ChangePasswordFailure implements Action {
    readonly type = ActionTypes.CHANGE_PASSWORD_FAILURE;

    constructor(public error: any) { }
}

export class UpdateAttribute implements Action {
    readonly type = ActionTypes.UPDATE_ATTRIBUTE;

    constructor(public data: UserAttributeModel) { }
}

export class UpdateAttributeSuccess implements Action {
    readonly type = ActionTypes.UPDATE_ATTRIBUTE_SUCCESS;

    constructor() { }
}

export class UpdateAttributeFailure implements Action {
    readonly type = ActionTypes.UPDATE_ATTRIBUTE_FAILURE;

    constructor(public error: any) { }
}

export class GotoSignIn implements Action {
    readonly type = ActionTypes.GOTO_SIGNIN;
}

export class SetRedirectUrl implements Action {
    readonly type = ActionTypes.SET_REDIRECT_URL;

    constructor(public url: string) { }
}

export class SetGsToken implements Action {
    readonly type = ActionTypes.SET_GS_TOKEN;

    constructor(public base64Token: string, public rawToken: string) { }
}



export class UpdateContact implements Action {
    readonly type = ActionTypes.UPDATE_CONTACT;
    constructor(public payload: any) {}
  }
  
  export class UpdateContactSuccess implements Action {
    readonly type = ActionTypes.UPDATE_CONTACT_SUCCESS;
  }
  
  export class UpdateContactFailure implements Action {
    readonly type = ActionTypes.UPDATE_CONTACT_FAILURE;
    constructor(public error: any) {}
  }

  export class GetPhoneNumber implements Action {
    readonly type = ActionTypes.GET_PHONE_NUMBER;
    constructor(public payload: any) {}
  }
  
  export class GetPhoneNumberSuccess implements Action {
    readonly type = ActionTypes.GET_PHONE_NUMBER_SUCCESS;
    constructor(public payload: any) {}
  }
  
  export class GetPhoneNumberFailure implements Action {
    readonly type = ActionTypes.GET_PHONE_NUMBER_FAILURE;
    constructor(public error: any) {}
  }

  export class ResetCode implements Action {
    readonly type = ActionTypes.RESET_CODE;

    constructor(public data: any) { }
}

export class ResetCodeSuccess implements Action {
    readonly type = ActionTypes.RESET_CODE_SUCCESS;

    constructor() { }
}

export class ResetCodeFailure implements Action {
    readonly type = ActionTypes.RESET_CODE_FAILURE;

    constructor(public error: any) { }
}

export class SignupCodeLogin implements Action {
    readonly type = ActionTypes.SIGNUP_CODE_LOGIN;

    constructor(public data: any) { }
}

export class SignupCodeLoginSuccess implements Action {
    readonly type = ActionTypes.SIGNUP_CODE_LOGIN_SUCCESS;

    constructor(public payload: any) { }
}

export class SignupCodeLoginFailure implements Action {
    readonly type = ActionTypes.SIGNUP_CODE_LOGIN_FAILURE;

    constructor(public error: any) { }
}


// GENERATE CODE
export class GenerateSignupCode implements Action {
    readonly type = ActionTypes.GENERATE_SIGNUP_CODE;

    constructor(public data: any) { }
}

export class GenerateSignupCodeSuccess implements Action {
    readonly type = ActionTypes.GENERATE_SIGNUP_CODE_SUCCESS;

    constructor(public payload: any) { }
}

export class GenerateSignupCodeFailure implements Action {
    readonly type = ActionTypes.GENERATE_SIGNUP_CODE_FAILURE;

    constructor(public error: any) { }
}


// GET ALL CODES
export class GetSignupCodes implements Action {
    readonly type = ActionTypes.GET_SIGNUP_CODES;
}

export class GetSignupCodesSuccess implements Action {
    readonly type = ActionTypes.GET_SIGNUP_CODES_SUCCESS;

    constructor(public payload: any) { }
}

export class GetSignupCodesFailure implements Action {
    readonly type = ActionTypes.GET_SIGNUP_CODES_FAILURE;

    constructor(public error: any) { }
}


// VALIDATE CODE
export class ValidateSignupCode implements Action {
    readonly type = ActionTypes.VALIDATE_SIGNUP_CODE;

    constructor(public data: any) { }
}

export class ValidateSignupCodeSuccess implements Action {
    readonly type = ActionTypes.VALIDATE_SIGNUP_CODE_SUCCESS;

    constructor(public payload: any) { }
}

// VALIDATE EMAIL
export class ValidateEmail implements Action {
    readonly type = ActionTypes.VALIDATE_EMAIL;

    constructor(public data: any) { }
}

export class ValidateEmailSuccess implements Action {
    readonly type = ActionTypes.VALIDATE_EMAIL_SUCCESS;

    constructor(public payload: any) { }
}

export class ValidateEmailFailure implements Action {
    readonly type = ActionTypes.VALIDATE_EMAIL_FAILURE;

    constructor(public error: any) { }
}

export class ValidateSignupCodeFailure implements Action {
    readonly type = ActionTypes.VALIDATE_SIGNUP_CODE_FAILURE;

    constructor(public error: any) { }
}



export type Actions
    = SignIn
    | SignInSuccess
    | SignInFailure

    | SignUp
    | SignUpSuccess
    | SignUpFailure

    | SignOut

    | ForgotPassword
    | ForgotPasswordSuccess
    | ForgotPasswordFailure

    | ForgotPasswordSubmit
    | ForgotPasswordSubmitSuccess
    | ForgotPasswordSubmitFailure

    | ChangePassword
    | ChangePasswordSuccess
    | ChangePasswordFailure

    | SSO
    | SSOSuccess
    | SSOFailure

    | UpdateAttribute
    | UpdateAttributeSuccess
    | UpdateAttributeFailure

    | GotoSignIn
    | SetRedirectUrl
   
    | UpdateContact
    | UpdateContactSuccess
    | UpdateContactFailure

    | ResetCode
    | ResetCodeSuccess
    | ResetCodeFailure

    | ValidateEmail
    | ValidateEmailSuccess
    | ValidateEmailSuccess